<div class="h-screen flex items-center justify-center p-6">
  <div class="flex flex-col items-start gap-12 w-full lg:w-2/4 2xl:w-2/5">
    <div class="flex justify-center items-start flex-col gap-4">
        <h1 class="text-3xl font-bold">Sorry!</h1>
        <h2 class="font-bold text-2xl">The page you are looking for cannot be found.</h2>
        <p class="text-gray-500">No worries for you, feel free to go back to your dashboard  :)</p>
    </div>
    <div class="flex flex-wrap gap-4 justify-between items-start w-full">
        <full-button (click)="navigateToDashboard()" text="Go to Dashboard"/>
        <div>
            <img alt="Page Not Found Image" src="../../../../assets/images/page-not-found.svg" class="pointer-events-none"/>
        </div>
    </div>
  </div>
</div>
